// hooks/useCart.js
import {
  addToCart,
  removeFromCart,
  clearCart,
  incrementQuantityWithAPI,
  decrementQuantityWithAPI,
  removeItemFromCartWithAPI
} from '@/redux/cartSlice';
import { logout } from '@/redux/userSlice';
import { useDispatch, useSelector } from 'react-redux';

const useCart = () => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state?.cart?.products);
  const cartId = useSelector((state) => state?.cart?.cart_id);

  const addProduct = (product) => dispatch(addToCart(product));
  const removeProduct = (product) => dispatch(removeItemFromCartWithAPI(product));

  const clear = () => {
    dispatch(clearCart());
    dispatch(logout());
  };

  const clearCartAfterCheckout = () => dispatch(clearCart());

  // Updated to include variantSizeId parameter
const increaseQty = (product_id, product_variation_id, variant_size_id, plating_id = null) =>
  dispatch(incrementQuantityWithAPI({ 
    productId: product_id, 
    variationId: product_variation_id,
    variantSizeId: variant_size_id,
    platingId: plating_id
  }));

// Updated to include variantSizeId and platingId parameters
const decreaseQty = (product_id, product_variation_id, variant_size_id, plating_id = null) =>
  dispatch(decrementQuantityWithAPI({ 
    productId: product_id, 
    variationId: product_variation_id,
    variantSizeId: variant_size_id,
    platingId: plating_id
  }));

  return {
    cartItems,
    cartId,
    addProduct,
    removeProduct,
    clear,
    clearCartAfterCheckout,
    increaseQty,
    decreaseQty,
  };
};

export default useCart;